import { c as _c } from "react/compiler-runtime";
import { IcoArrowDown16, IcoArrowUp16, IcoPlusSmall16, IcoTrash16 } from '@onefootprint/icons';
import { IconButton, LinkButton } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { InlineText } from '../../components/shared/inline-edit';
import { useBuilder } from '../../store/provider';
import type { RuleGroup } from '../../store/types';
import { uid } from '../../store/utils';
import ConditionRow from './condition-row';
type GroupCardProps = {
  rulesNodeId: string;
  group: RuleGroup;
  canUp: boolean;
  canDown: boolean;
  canRemove: boolean;
  children?: ReactNode;
};
const GroupCard = t0 => {
  const $ = _c(53);
  const {
    rulesNodeId,
    group,
    canUp,
    canDown,
    canRemove,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.rules.group"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    actions,
    isReadOnly
  } = useBuilder();
  const canEdit = !isReadOnly;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="shrink-0 text-body-3 text-tertiary">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = group.value;
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp2);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp3);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== actions.rules || $[10] !== group.id || $[11] !== rulesNodeId) {
    t7 = next => actions.rules.updateGroup(rulesNodeId, group.id, {
      value: next
    });
    $[9] = actions.rules;
    $[10] = group.id;
    $[11] = rulesNodeId;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== canEdit || $[14] !== group.value || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <InlineText value={t4} ariaLabel={t5} placeholder={t6} canEdit={canEdit} onChange={t7} />;
    $[13] = canEdit;
    $[14] = group.value;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== actions.rules || $[20] !== canDown || $[21] !== canEdit || $[22] !== canRemove || $[23] !== canUp || $[24] !== group.id || $[25] !== rulesNodeId || $[26] !== t) {
    t9 = canEdit && <div className="ml-auto flex items-center gap-0.5">{canUp && <IconButton size="tiny" aria-label={t(_temp4)} icon={IcoArrowUp16} onClick={() => actions.rules.moveGroup(rulesNodeId, group.id, "up")} />}{canDown && <IconButton size="tiny" aria-label={t(_temp5)} icon={IcoArrowDown16} onClick={() => actions.rules.moveGroup(rulesNodeId, group.id, "down")} />}{canRemove && <IconButton size="tiny" aria-label={t(_temp6)} icon={IcoTrash16} destructive={true} onClick={() => actions.rules.removeGroup(rulesNodeId, group.id)} />}</div>;
    $[19] = actions.rules;
    $[20] = canDown;
    $[21] = canEdit;
    $[22] = canRemove;
    $[23] = canUp;
    $[24] = group.id;
    $[25] = rulesNodeId;
    $[26] = t;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t3 || $[29] !== t8 || $[30] !== t9) {
    t10 = <div className="flex h-8 items-center gap-2 rounded-t border-b border-tertiary bg-secondary px-2">{t3}{t8}{t9}</div>;
    $[28] = t3;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== group.conditions || $[33] !== group.id || $[34] !== rulesNodeId) {
    let t12;
    if ($[36] !== group.conditions.length || $[37] !== group.id || $[38] !== rulesNodeId) {
      t12 = (c, i) => <ConditionRow key={c.id} rulesNodeId={rulesNodeId} groupId={group.id} condition={c} index={i} canRemove={group.conditions.length > 1} />;
      $[36] = group.conditions.length;
      $[37] = group.id;
      $[38] = rulesNodeId;
      $[39] = t12;
    } else {
      t12 = $[39];
    }
    t11 = group.conditions.map(t12);
    $[32] = group.conditions;
    $[33] = group.id;
    $[34] = rulesNodeId;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[40] !== actions.rules || $[41] !== canEdit || $[42] !== group.id || $[43] !== rulesNodeId || $[44] !== t) {
    t12 = canEdit && <div className="mt-1 self-start"><LinkButton variant="caption-3" iconComponent={IcoPlusSmall16} iconPosition="left" onClick={() => actions.rules.addCondition(rulesNodeId, group.id, uid("cond"))}>{t(_temp7)}</LinkButton></div>;
    $[40] = actions.rules;
    $[41] = canEdit;
    $[42] = group.id;
    $[43] = rulesNodeId;
    $[44] = t;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== children || $[47] !== t11 || $[48] !== t12) {
    t13 = <div className="flex flex-col gap-3 p-3">{t11}{t12}{children}</div>;
    $[46] = children;
    $[47] = t11;
    $[48] = t12;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  let t14;
  if ($[50] !== t10 || $[51] !== t13) {
    t14 = <div className="flex flex-col rounded border border-tertiary">{t10}{t13}</div>;
    $[50] = t10;
    $[51] = t13;
    $[52] = t14;
  } else {
    t14 = $[52];
  }
  return t14;
};
export default GroupCard;
function _temp($) {
  return $.setValueTo;
}
function _temp2($_0) {
  return $_0.valueAria;
}
function _temp3($_1) {
  return $_1.valuePlaceholder;
}
function _temp4($_2) {
  return $_2.moveUp;
}
function _temp5($_3) {
  return $_3.moveDown;
}
function _temp6($_4) {
  return $_4.remove;
}
function _temp7($_5) {
  return $_5.addCondition;
}